<template>
  <div id="new_password" @click="closeMenu()">
    <dd-header
      ref="menuRef"
      :headerType=2
    />
    <div id="container">
      <div id="content">
        <div class="title">
          <h2>パスワードの更新</h2>
        </div>
        <dd-password-input
          ref="passwordInput"
          :passwordForm="passwordForm"
        />
        <div id="regist_btn">
          <button class="main_btn cancel_btn" @click="cancel()">戻る</button>
          <button class="main_btn" @click="update()">更新する</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../../utils/Api'
// Module
import Header from '../components/common/DcHeader'
import PasswordInput from '../components/user/PasswordInput'
import {DC_URL} from '../../constants/App'

export default {
  name: 'UpdatePasswordInput',
  components: {
    'dd-header': Header,
    'dd-password-input': PasswordInput
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      passwordForm: {
        password: '',
        confirmPassword: ''
      },
      errors: {}
    }
  },
  computed: {
  },
  methods: {
    cancel: function () {
      this.$router.go(-1)
    },
    update: function () {
      let ret = this.$refs.passwordInput.confirm()
      if (!ret) return

      // DBに登録する
      let payload = {
        password: this.passwordForm.password,
        confirmPassword: this.passwordForm.confirmPassword
      }
      axios.post(DC_URL.USER + '/update-password', payload
      ).then(response => {
        if (response.data.errorMessage) {
        //   this.fieldErrorMessages.password = response.data.errorMessage
        //   this.$refs.passwordInput.setErrorMessage(this.fieldErrorMessages)
        } else {
          this.$router.push({
            name: 'UpdateUserConfirm'
          })
        }
      }).catch(error => {
        Api.handleError(error, this.errorMessage, this.validateErrorMessages)
      })
    },
    closeMenu: function () {
      this.$refs.menuRef.close()
    }
  },
  created () {
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style src="../css/input-list.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/UpdatePasswordInput.vue